const beOneBlackicon =

 <svg className="beOneIcon"  version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="2101.000000pt" height="2401.000000pt" viewBox="0 0 2101.000000 2401.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,2401.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path className="grey" d="M10090 20123 c-25 -1 -112 -8 -195 -13 -482 -34 -1015 -123 -1490
-251 -1229 -330 -2317 -915 -3295 -1773 -153 -134 -538 -519 -682 -681 -965
-1090 -1610 -2384 -1892 -3796 -119 -596 -162 -1080 -153 -1727 5 -389 18
-580 58 -897 286 -2254 1496 -4273 3356 -5601 549 -392 1206 -742 1838 -980
754 -283 1504 -444 2350 -505 216 -16 822 -16 1025 0 240 18 449 40 635 67 93
13 170 24 172 24 2 0 3 944 3 2098 l0 2097 -62 39 c-248 154 -497 388 -691
649 l-80 107 -49 -77 c-199 -310 -471 -570 -795 -760 l-113 -66 0 -1184 0
-1184 -42 5 c-24 3 -92 10 -153 17 -416 41 -863 138 -1285 279 -717 238 -1343
588 -1935 1079 -193 160 -576 543 -736 736 -855 1030 -1341 2234 -1469 3635
-18 196 -24 768 -11 985 69 1110 378 2119 929 3030 909 1503 2385 2514 4092
2804 640 109 1325 120 1975 30 1930 -264 3586 -1468 4499 -3269 378 -745 599
-1510 693 -2395 22 -214 26 -993 5 -1195 -61 -593 -150 -1023 -317 -1525 -120
-361 -209 -575 -380 -915 -455 -900 -1118 -1676 -1918 -2243 -159 -113 -394
-262 -534 -337 l-102 -55 -1 -987 c0 -604 4 -988 9 -988 5 0 81 29 168 64
1030 414 1943 1017 2728 1801 1785 1783 2634 4273 2314 6785 -174 1369 -707
2690 -1531 3795 -249 334 -440 556 -738 858 -317 323 -575 550 -912 802 -1290
968 -2783 1515 -4413 1615 -144 9 -763 11 -875 3z"/>
<path className="grey" d="M9940 16599 c-998 -804 -1828 -1471 -1844 -1484 l-29 -23 568 -663
c312 -365 575 -672 584 -682 16 -17 35 -2 379 293 199 170 364 310 367 310 3
0 6 -343 7 -762 l3 -761 135 -79 c317 -186 568 -418 761 -706 38 -56 72 -101
76 -100 4 2 48 57 97 123 167 221 409 450 634 598 l92 61 0 2668 c0 1467 -3
2668 -7 2668 -5 0 -825 -658 -1823 -1461z"/>
<path className="grey" d="M6422 11108 l3 -2813 603 -3 602 -2 0 225 c0 124 3 225 8 225 4 0 25
-28 46 -61 79 -123 261 -276 425 -359 480 -240 1138 -221 1696 50 270 131 471
287 661 513 215 256 362 557 443 912 l28 120 13 -55 c26 -113 94 -299 154
-425 118 -245 244 -423 436 -616 425 -426 985 -659 1582 -659 823 1 1560 478
1970 1275 37 72 71 142 77 158 l11 27 -648 0 -647 0 -58 -70 c-116 -138 -276
-244 -444 -292 -69 -20 -99 -23 -268 -22 -173 0 -199 3 -288 27 -201 54 -389
174 -504 322 -89 114 -164 277 -180 390 l-6 45 1579 2 1579 3 13 80 c20 123
10 507 -17 658 -90 505 -299 922 -630 1254 -586 591 -1473 794 -2276 522 -130
-44 -354 -155 -475 -236 -458 -304 -799 -781 -944 -1321 l-22 -83 -27 124
c-90 412 -275 757 -558 1037 -534 529 -1377 736 -2065 505 -207 -69 -385 -172
-528 -306 l-76 -71 -2 864 -3 863 -633 3 -632 2 2 -2812z m6868 467 c237 -36
441 -149 581 -322 86 -107 156 -244 183 -355 l6 -28 -955 0 -955 0 6 28 c40
167 171 372 306 480 80 63 209 133 302 163 149 47 353 61 526 34z m-4493 -106
c384 -43 691 -282 841 -657 89 -221 100 -488 30 -727 -67 -229 -228 -450 -423
-580 -281 -187 -655 -225 -975 -99 -515 203 -768 858 -550 1423 37 96 122 233
196 318 153 173 397 296 640 322 115 12 135 12 241 0z"/>
</g>
</svg>

export default beOneBlackicon;